export enum ActionType {
  TILE = 'tile',
  CAST = 'cast',
  EXTERNAL = 'external',
  INTERNAL = 'internal',
  SHARE = 'share',
  SHOP = 'shop',
  SHOPIFY = 'shopify',
  INFO = 'info',
}
